
import React from 'react';
import { Form, Button, Col, Row } from 'react-bootstrap';
import classes from './style.module.css';
import { LOGIN_PAGE_FORM_FIELDS } from '../../../constants/Constants'
import PropTypes from 'prop-types';

const LoginForm = props => {

    let forgotPassword = <a href="#" className={classes.ForgotPassword} onClick={(e) => { e.preventDefault(); props.forgotPasswordLinkClicked(); }}>Forgot Password?</a>
    if(props.enableForgotPassword === false) forgotPassword = null

    return(
        <Form className={classes.LoginForm}>
                <div className={classes.LoginTitle}>{props.title}</div>
                <div className={classes.LoginSubtitle}>Sign in to your account</div>

                <div className={classes.FormGroup}>
                    <label className={classes.FormLabel} htmlFor="loginFormUsernameInput">
                        {LOGIN_PAGE_FORM_FIELDS.USERNAME_TEXT.label}
                    </label>
                    <input
                        id="loginFormUsernameInput"
                        className={classes.FormControl}
                        key={LOGIN_PAGE_FORM_FIELDS.USERNAME_TEXT.key}
                        type="text"
                        placeholder={LOGIN_PAGE_FORM_FIELDS.USERNAME_TEXT.placeHolder}
                        value={props.username === null ? "" : props.username}
                        onChange={(event) => { props.clearErrorAndSuccessMessages(); props.loginDetailsChanged(LOGIN_PAGE_FORM_FIELDS.USERNAME_TEXT.key, event.target.value);  }} />
                </div>

                <div className={classes.FormGroup}>
                    <label className={classes.FormLabel} htmlFor="loginFormPasswordInput">
                        {LOGIN_PAGE_FORM_FIELDS.PASSWORD_TEXT.label}
                    </label>
                    <input
                        id="loginFormPasswordInput"
                        className={classes.FormControl}
                        key={LOGIN_PAGE_FORM_FIELDS.PASSWORD_TEXT.key}
                        type="password"
                        placeholder={LOGIN_PAGE_FORM_FIELDS.PASSWORD_TEXT.placeHolder}
                        value={props.password === null ? "" : props.password}
                        onChange={(event) => { props.clearErrorAndSuccessMessages(); props.loginDetailsChanged(LOGIN_PAGE_FORM_FIELDS.PASSWORD_TEXT.key, event.target.value) }} />
                </div>

                <div className={classes.CheckboxRow}>
                    <div className={classes.CheckboxWrapper}>
                        <input
                            id="loginFormSavePasswordCheckbox"
                            key={LOGIN_PAGE_FORM_FIELDS.SAVE_PASSWORD_FLAG_CHECK_BOX.key}
                            type="checkbox"
                            onChange={(event) => { props.clearErrorAndSuccessMessages(); props.loginDetailsChanged(LOGIN_PAGE_FORM_FIELDS.SAVE_PASSWORD_FLAG_CHECK_BOX.key, event.target.checked) }} />
                        <label className={classes.CheckboxLabel} htmlFor="loginFormSavePasswordCheckbox">
                            {LOGIN_PAGE_FORM_FIELDS.SAVE_PASSWORD_FLAG_CHECK_BOX.label}
                        </label>
                    </div>
                    <div>{forgotPassword}</div>
                </div>

                <button
                    type="button"
                    className={classes.SignInButton}
                    onClick={props.loginButtonClicked}>
                    Sign In
                </button>
            </Form>
    )
}

LoginForm.propTypes = {
    username: PropTypes.string,
    password: PropTypes.string,
    enableForgotPassword: PropTypes.bool,
    loginDetailsChanged: PropTypes.func.isRequired,
    loginButtonClicked: PropTypes.func.isRequired
}

export default LoginForm